export default __webpack_public_path__ + "static/media/SENAIT_NL_SEQ16.641de643.mp3";